import { type ExperienceNameType } from '@atlassian/conversation-assistant-instrumentation';
import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

export type AifcExperienceStatus = 'success' | 'fail' | 'abort';

// Shared properties for all experience tracking commands
export type BaseAifcExperienceTrackingProps = CommandProperties & {
	experienceName: ExperienceNameType;
	actionType?: string;
	actionId?: string;
	contentContext?: string;
	attributes?: Record<string, any>;
};

/**
 * Command for reporting the experience tracking status (success/failure/abort)
 * of an AI-first creation preview. Sent from the editor/iframe to the parent/host.
 */
export type AifcExperienceTrackingCommandProperties =
	| (BaseAifcExperienceTrackingProps & { status: 'success'; error?: never; reason?: never })
	| (BaseAifcExperienceTrackingProps & { status: 'fail'; error: string; reason?: never })
	| (BaseAifcExperienceTrackingProps & { status: 'abort'; reason: string; error?: never });

export const AifcExperienceTrackingCommand = createCommand<AifcExperienceTrackingCommandProperties>(
	'aifc-experience-tracking-command',
);
